import { useQuery } from '@apollo/client';
import { isNil } from 'ramda';

import { USER_PROFILE_QUERY } from './useUser.query.gql';

type UseUserProps = {
  userId?: string;
};
export const useUser = ({ userId }: UseUserProps) => {
  const { data, loading } = useQuery(USER_PROFILE_QUERY, {
    variables: {
      userId,
    },
    skip: isNil(userId),
  });

  return {
    id: data?.astronaut.user.id,
    primarySourceReference: data?.astronaut.user.primarySourceReference,
    profile: data?.astronaut.user.profile,
    loading,
  };
};
